<template>
  <div class="content-page">
    <div class="bd">
        <div class="course-title">快速创建微信小程序流程</div>
        <div class="course-blak-30"></div>
        <div class="course-text">一．介绍</div>
        <div class="course-blak-20"></div>
        <div class="course-p">
            快速创建小程序接口优化了小程序注册认证的流程，用于帮助商户快速注册小程序。<br/>采用法人人脸识别方式替代小额打款等认证流程，极大的减轻了小程序主体、类目资质信息收集的人力成本。<br/>
            只需收集<span class="fontWeight">法人姓名、法人微信、企业名称、企业代码信息</span>这四个信息，便可以向企业法人下发一条模板消息来采集法人人脸信息，完成全部注册、认证流程。以及法人收到创建成功后的小程序APPID，以及后续授权过程。
        </div>
        <div class="course-blak-20"></div>
        <div class="course-p">重点：</div>
        <div class="course-p">(1) 申请小程序必须以企业为主体</div>
        <div class="course-p">(2) 需要填写法人微信号和姓名</div>
        <div class="course-p">(3) （3）提交后1个工作日内，及时查看审核消息，及时完成实名认证</div>
        <div class="course-blak-30"></div>
        <div class="course-text">二．流程</div>
        <div class="course-blak-20"></div>
        <div class="course-p">2.1 创建入口</div>
        <div class="course-p" style="padding-left:20px;">还未申请小程序的用户，可选择立即创建，进入小程序创建流程。</div>
        <img src="@/assets/img/createMiniProgram/first.png" alt="" class="course-img">
        <img src="@/assets/img/createMiniProgram/second.png" alt="" class="course-img">
        <div class="course-p">2.2 需要填写：法人微信、法人姓名、企业名称、信用代码四个商户信息，点击【提交】</div>
        <div class="course-p">2.3企业名称需与工商部门登记信息一致；法人姓名与绑定微信银行卡的姓名一致</div>
        <div class="course-p">2.4通过法人&企业主体校验，微信平台会向法人微信下发模板消息。法人需在<span class="fontWeight">24 小时内</span>点击消息，进行身份证信息与人脸识别信息收集</div>   
        <div class="course-p">具体操作如下：</div> 
        <img src="@/assets/img/createMiniProgram/third.png" alt="" class="course-img">
        <div class="course-blak-30"></div>
        <div class="course-p">2.5、信息收集完毕，验证通过后，会自动完成授权,请及时联系我司运营人员设置：小程序昵称、头像、介绍、类目。完成后后续可选择模板，完成小程序上架后续流程</div>
        <div class="course-blak-20"></div>
        <img src="@/assets/img/createMiniProgram/fourth.png" alt="" class="course-img">
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    }
}
</script>

<style lang="less" scoped>
.content-page {
    .bd {
        height: 100%;
        padding: 20px;
    }
}
</style>